import { axiosRubyClient } from '@/util/axios/axiosClient';

export type AppVersionChannel = 'production' | 'preview';

export type AppVersionPin = {
  id: number;
  channel: AppVersionChannel;
  allowed_update_ids: string[];
  max_allowed_count: number;
  gate_enabled: boolean;
  notes: string | null;
  last_synced_at: string | null;
  created_at: string | null;
  updated_at: string | null;
};

export type AppVersionPinPayload = {
  channel: AppVersionChannel;
  allowed_update_ids?: string[];
  max_allowed_count?: number;
  gate_enabled?: boolean;
  notes?: string | null;
};

export type AppVersionPinUpdatePayload = Partial<AppVersionPinPayload>;

type ListResponse = { success: true; data: AppVersionPin[] };
type ShowResponse = { success: true; data: AppVersionPin };
type DeleteResponse = { success: true };
type RefreshResponse =
  | { success: true; data: AppVersionPin }
  | { success: false; errors: string[]; data: AppVersionPin };

export const fetchAppVersionPins = async (): Promise<ListResponse> => {
  const response = await axiosRubyClient.get('/api/admin/app_version_pins');
  return response.data;
};

export const createAppVersionPin = async (
  data: AppVersionPinPayload,
): Promise<ShowResponse> => {
  const response = await axiosRubyClient.post('/api/admin/app_version_pins', {
    app_version_pin: data,
  });
  return response.data;
};

export const updateAppVersionPin = async (
  id: number,
  data: AppVersionPinUpdatePayload,
): Promise<ShowResponse> => {
  const response = await axiosRubyClient.patch(
    `/api/admin/app_version_pins/${id}`,
    { app_version_pin: data },
  );
  return response.data;
};

export const deleteAppVersionPin = async (
  id: number,
): Promise<DeleteResponse> => {
  const response = await axiosRubyClient.delete(
    `/api/admin/app_version_pins/${id}`,
  );
  return response.data;
};

export const refreshAppVersionPinFromExpo = async (
  id: number,
): Promise<RefreshResponse> => {
  const response = await axiosRubyClient.post(
    `/api/admin/app_version_pins/${id}/refresh_from_expo`,
    {},
    // Don't throw on 422 — the controller returns the unchanged pin in
    // the body so the UI can keep showing the row with an error toast.
    { validateStatus: (status) => status < 500 },
  );
  return response.data;
};
